export interface ContentBlock {
  title: string
  lead: string
  body: string[]
  close?: string
}

export const modules: ContentBlock[] = [
  {
    title: 'MODULE 1 — Cinnamon Roll Foundations™',
    lead: 'Build the foundation correctly before making your first batch.',
    body: [
      'Learn how to choose and prepare your ingredients, understand flour, yeast, butter, milk, sugar, cinnamon and other essential components, organize your workspace, use the right tools, measure accurately, and prepare everything before production begins.',
    ],
    close: 'Start with the right ingredients, tools, and process.',
  },
  {
    title: 'MODULE 2 — Perfect Dough System™',
    lead: 'Learn the complete process for creating soft, fluffy and consistent cinnamon roll dough.',
    body: [
      'Mixing. Kneading. Hydration. Gluten development. Dough temperature. First fermentation. Texture control. Common problems. Corrections.',
    ],
    close:
      'Follow a clear process designed to help you understand not only what to do — but how to recognize when your dough is actually ready.',
  },
  {
    title: 'MODULE 3 — Filling & Flavor System™',
    lead: 'Turn one strong foundation into multiple product possibilities.',
    body: [
      'Learn how to prepare balanced cinnamon fillings and build different flavor combinations using chocolate, caramel, nuts, fruit, coffee, maple and other complementary ingredients.',
      "Understand how to control sweetness, moisture and texture so you're not simply adding ingredients and hoping they work.",
    ],
    close: 'Create products that look and taste intentionally made.',
  },
  {
    title: 'MODULE 4 — Roll, Cut & Proof™',
    lead: 'Transform your dough into uniform, professional-looking cinnamon rolls.',
    body: [
      'Learn how to: roll correctly, control tension, create defined spirals, cut consistent portions, prepare different sizes, arrange your trays, manage the second proof, and recognize when your rolls are ready for the oven.',
    ],
    close: 'Consistency starts before baking.',
  },
  {
    title: 'MODULE 5 — Perfect Bake Method™',
    lead: 'Learn how to bake for softness, moisture, structure and repeatability.',
    body: [
      'Understand temperature, timing, tray position, different roll sizes, visual baking signals and the most common reasons cinnamon rolls become dry, raw in the center, overly dark or inconsistent.',
      'Stop relying only on a timer.',
    ],
    close: 'Learn how to recognize a properly baked product.',
  },
  {
    title: 'MODULE 6 — Frosting, Finish & Presentation™',
    lead: 'This is where a good cinnamon roll becomes a product you can be proud to offer.',
    body: [
      'Learn how to prepare and apply: cream cheese frosting, vanilla glaze, chocolate finishes, caramel, coffee and maple glazes, premium toppings, drizzles, and professional finishing combinations.',
      'Then bring everything together with clean, consistent presentation.',
    ],
    close: 'From the oven to the finished product.',
  },
]

export const bonuses: ContentBlock[] = [
  {
    title: 'BONUS 1 — 50 Cinnamon Roll Flavor Formulas™',
    lead: 'Go beyond one basic cinnamon roll.',
    body: [
      'Access a complete collection of flavor formulas covering classic cinnamon, chocolate, caramel, nuts, fruit, coffee, maple, premium combinations and more.',
      'Learn how fillings, frostings and toppings work together so you can develop a more varied product selection.',
    ],
  },
  {
    title: 'BONUS 2 — Batch Production & Prep System™',
    lead: 'Once you start preparing more than one batch, organization matters.',
    body: [
      'Learn how to plan ingredients, scale formulas, prepare multiple batches, organize your workspace, manage fermentation timing, control oven flow and document your production.',
      'Move from casual baking toward a more organized production process.',
    ],
  },
  {
    title: 'BONUS 3 — Storage, Freezing & Freshness Guide™',
    lead: 'Learn the principles behind protecting softness, texture, appearance and overall product quality.',
    body: [
      "Understand cooling, storage, refrigeration, freezing, thawing, reheating and component management so you can make better decisions based on the ingredients and products you're preparing.",
    ],
  },
  {
    title: 'BONUS 4 — Premium Finish & Presentation Book™',
    lead: 'Make your cinnamon rolls look as good as they taste.',
    body: [
      'Learn frosting consistencies, glazes, drizzles, toppings, premium combinations, finishing styles, presentation techniques and consistency between units.',
      "Create the kind of product you'd feel confident putting in front of a customer.",
    ],
  },
  {
    title: 'BONUS 5 — Cinnamon Roll Troubleshooting Bible™',
    lead: 'Something went wrong?',
    body: [
      "Don't immediately throw away your process and start over.",
      'Use a structured troubleshooting system for problems involving dough, fermentation, filling, shaping, baking, texture, frosting, presentation and storage.',
      'Identify the problem. Understand the likely cause. Correct the process. Improve the next batch.',
    ],
  },
]
